/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalStatusViewModel } from "../types/PersonDocumentApprovalStatusViewModel.ts";
import { personDocumentApprovalRgAnalysisViewModelSchema } from "./personDocumentApprovalRgAnalysisViewModelSchema.ts";

export const personDocumentApprovalStatusViewModelSchema = z.object({
  attachmentId: z
    .number()
    .int()
    .describe(
      "ID do anexo; nulo quando o aluno não anexou o documento (modelo default). Opcional.",
    )
    .nullish(),
  personId: z.optional(z.number().int().describe("ID da pessoa (aluno).")),
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  enrollmentDocumentId: z.optional(
    z.number().int().describe("ID do documento de matrícula (tipo)."),
  ),
  description: z
    .string()
    .describe('Descrição do anexo; "DEFAULT" no modelo default. Opcional.')
    .nullish(),
  path: z
    .string()
    .describe("Caminho do arquivo no storage. Opcional.")
    .nullish(),
  url: z
    .string()
    .describe(
      "URL SAS do arquivo para exibição inline no front; nula quando não há arquivo. Opcional.",
    )
    .nullish(),
  isPdf: z.optional(
    z.boolean().describe("Indica se o arquivo é PDF (senão, imagem)."),
  ),
  active: z.optional(z.boolean().describe("Indica se o anexo está ativo.")),
  creationDate: z
    .string()
    .datetime()
    .describe(
      "Data de criação do anexo; data atual no modelo default. Opcional.",
    )
    .nullish(),
  hasCourseIRI: z.optional(
    z.boolean().describe("Indica se o anexo pertence a curso IRI."),
  ),
  documentationStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status agrupado do documento (considera todos os anexos do tipo). Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
      ),
  ),
  documentationStatusText: z
    .string()
    .describe("Descrição do status agrupado (pt-BR).")
    .nullish(),
  analysisStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status do reconhecimento automático do anexo. Enum EAnalysisStatus: `0` = Recognized, `1` = NotRecognized, `2` = SentToAnalysis, `3` = NotAnalyzed.",
      ),
  ),
  analysisStatusText: z
    .string()
    .describe("Descrição do status do reconhecimento automático (pt-BR).")
    .nullish(),
  hasAnalysisStatus: z.optional(
    z
      .boolean()
      .describe("Indica se existe registro de reconhecimento automático (RG)."),
  ),
  showAutomaticRecognition: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o botão de reconhecimento automático deve aparecer (documento RG com análise reconhecida).",
      ),
  ),
  rgAnalysis: z.optional(
    z.lazy(() => personDocumentApprovalRgAnalysisViewModelSchema),
  ),
}) as unknown as ToZod<PersonDocumentApprovalStatusViewModel>;
